{
  "cookies-dialog": {
    "buttons": {
      "accept-all": "Accept all cookies",
      "save": "Save settings",
      "setting": "Cookies setting"
    },
    "text": {
      "title": "Privacy & Cookies",
      "content-1": "We use analytics (e.g. cookies or fingerprints) to measure how often our site is visited and how it is used. We also use technical third-party content to simplify tag control (tag manager).",
      "content-2": "In this context, we also use service providers in third countries outside the EU without an adequate level of data protection, which entails the following risks: Access by authorities without information, no data subject rights, no legal remedies, loss of control.",
      "content-3": "You can find more information about the use of your data in our privacy policy. With your setting, you consent to the processes described above.",
      "essential-cookies": "Essential",
      "essential-cookies-description": "Essential cookies enable basic functions and are necessary for the proper function of the website.",
      "statistics-cookies": "Analytics & Statistics",
      "statistics-cookies-description": "Analytics & Statistics cookies collect information anonymously. This information helps us to understand how our visitors use our website."
    }
  }
}
